<ng-template #changingStatus>
  <mat-spinner class="center"></mat-spinner>
  <h3 class="center">Please wait...</h3>
</ng-template>


<div fxLayout="column" fxLayoutAlign="start" fxLayoutGap="3%">

  <h1 matDialogTitle>
    Changing box activation status!
  </h1>
  <mat-dialog-content>
    <ng-container *ngIf="!saving else changingStatus!">
      <aw-general-item-detail-dialog fxFlexAlign="stretch" [inputData]="_box"
        [disableCloseButton]="true"></aw-general-item-detail-dialog>
    </ng-container>
  </mat-dialog-content>



  <mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
    <button mat-flat-button color="primary" (click)="enableOrDisable()" [disabled]="saving">
      {{label2}}
    </button>
    <button mat-button matDialogClose>CLOSE</button>
  </mat-dialog-actions>
</div>